import { atom } from "@byko/lib-recoil";

import { Key } from "./const";

export const loadingCartState = atom<Record<string, null | number>>({
  key: Key("LoadingCartState"),
  default: {},
});
